// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EeHur","content":"styles_content__2OOV8"};